import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

import { getACHStatus, getACHStatusColor } from '@pumpkincare/claims';

function ACHStatus({
  fundingSource = {
    account_type: '',
    account_number: '',
  },
  ...rest
}) {
  const status = getACHStatus(fundingSource);
  const style = getACHStatusColor(status);

  return (
    <Typography style={style} {...rest}>
      {status}
    </Typography>
  );
}

ACHStatus.propTypes = {
  fundingSource: PropTypes.shape({
    account_type: PropTypes.string,
    account_number: PropTypes.string,
  }),
};

export default ACHStatus;
